export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const NEW_HARD_DEVICES = 'NEW_HARD_DEVICES';
export const CREATE_HARD_DEVICES_START = 'CREATE_HARD_DEVICES_START';
export const CREATE_HARD_DEVICES_SUCCESS = 'CREATE_HARD_DEVICES_SUCCESS';
export const CREATE_HARD_DEVICES_FAILURE = 'CREATE_HARD_DEVICES_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const SWITCH_DEVICES_START = 'SWITCH_DEVICES_START';
export const SWITCH_DEVICES_SUCCESS = 'SWITCH_DEVICES_SUCCESS';
export const SWITCH_DEVICES_FAILURE = 'SWITCH_DEVICES_FAILURE';

export const RESET_TIME_CORRECTIONS_START = 'RESET_TIME_CORRECTIONS_START';
export const RESET_TIME_CORRECTIONS_SUCCESS = 'RESET_TIME_CORRECTIONS_SUCCESS';
export const RESET_TIME_CORRECTIONS_FAILURE = 'RESET_TIME_CORRECTIONS_FAILURE';

export const REMOVAL_USERS_START = 'REMOVAL_USERS_START';
export const REMOVAL_USERS_SUCCESS = 'REMOVAL_USERS_SUCCESS';
export const REMOVAL_USERS_FAILURE = 'REMOVAL_USERS_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
